
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '@/components/ui/chart';
import { useEffect, useState } from 'react';

interface OrderAnalyticsChartProps {
  storeId: string;
  data: { name: string; completed: number; cancelled: number }[];
}

export const OrderAnalyticsChart = ({ storeId, data }: OrderAnalyticsChartProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (data) {
      setIsLoading(false);
    }
  }, [data]);

  return (
    <Card className="col-span-full animate-fade-in">
      <CardHeader>
        <CardTitle>{t('dashboardCharts.orderPerformance')}</CardTitle>
        <CardDescription>
          {t('dashboardCharts.orderPerformanceDescription')}
        </CardDescription>
      </CardHeader>
      <CardContent className="h-80">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <p>{t('loading')}</p>
          </div>
        ) : (
          <ChartContainer 
            config={{
              completed: {
                label: t('dashboardCharts.completed'),
                theme: {
                  light: '#1EAEDB',
                  dark: '#3DB9E6',
                },
              },
              cancelled: {
                label: t('dashboardCharts.cancelled'),
                theme: {
                  light: '#E57373',
                  dark: '#F48FB1',
                },
              },
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<ChartTooltipContent />} />
                <Bar 
                  dataKey="completed" 
                  fill="var(--color-completed, #1EAEDB)" 
                  radius={[4, 4, 0, 0]} 
                />
                <Bar 
                  dataKey="cancelled" 
                  fill="var(--color-cancelled, #E57373)" 
                  radius={[4, 4, 0, 0]} 
                />
              </BarChart>
            </ResponsiveContainer>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
};
